export const goodsTableOption = {
    // 帖子列表信息
    page:false,
    border: true,
    stripe: true,
    align:'center',
    menuAlign:'center',
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    addBtn: false,
    searchShow: false,
    searchBtn: false,
    column: [{
      label: 'ID',
      prop: 'id',
      width: 120,
    },{
      label: '商品预览',
      width: 260,
      prop: 'name',
      overHidden: true,
      solt: true,
      align: 'left'
    },{
      label: '积分值',
      prop: 'rewardValue',
      sortable: true,
      width: 120,
    },{
      label: '折扣价',
      prop: 'discount',
      sortable: true,
      width: 120,
    },{
      label: '库存',
      prop: 'sku',
      sortable: true,
      width: 120,
    },{
      label: '销量',
      prop: 'explainSku',
      solt: true,
      sortable: true,
      width: 120,
    },{
      label: '剩余库存',
      prop: 'remainSku',
      sortable: true,
      width: 120,
    },{
      label: '兑换限制',
      prop: 'exchangeLimit',
      width: 120,
    },{
      label: '商品分类',
      prop: 'goodsTypes',
      overHidden: true,
      width: 120,
    },{
      label: '核销类型',
      prop: 'redeemType',
      overHidden: true,
      width: 120,
    },{
      label: '置顶级别',
      prop: 'sort',
      sortable: true,
      width: 120,
    },{
      label: '发布者',
      width: 160,
      prop: 'creator',
      overHidden: true,
      align: 'left'
    },{
      label: '发布时间',
      prop: 'insertedTime',
      sortable: true,
      align: 'left',
      width: 160,
    }, {
      label: '是否下架',
      prop: 'isNotBanned',
      width: 110,
    },{
      label: '下架原因',
      prop: 'banComment',
      overHidden: true,
      hide: true,
      align: 'left',
      width: 160,
    }]
  }
  
export const redeemTypeOptions = [
  { label: '线上', value: 1 },
  { label: '线下', value: 2 },
  { label: '虚拟', value: 3 },
  { label: '实物兑换', value: 4 },
]